import React from "react";
import Props from "./index.type";

function Button(props: Props) {
  const { children, className, ...others } = props;

  return (
    <button className={`btn btn-outline-primary rounded ${className}`} {...others}>
      {children}
    </button>
  );
}

export default Button;